module.exports = __webpack_public_path__ + "static/media/nodejs.68ab02ab.svg";